import styled, {css} from "styled-components"

interface Props {
  isMobile: boolean
}

export const BusinessLogo = styled.img<Props>`
  ${({theme, isMobile}) => css`
    margin-top: ${theme.spacing.two};
    margin-bottom: ${theme.spacing.two};
    max-width: ${isMobile ? `150px` : `250px`};
    max-height: ${isMobile ? `50px` : `100px`};
  `}
`
